import React, { Fragment } from "react";
import { Route, Navigate } from "react-router-dom";
import TenantDashboard from "../pages/company/dashboard/TenantDashboard";
import ActionCenter from "../pages/company/dashboard/ActionCenter";
import TodaysSchedule from "../pages/company/dashboard/TodaysSchedule";
import UserList from "../pages/company/users/UserList";
import UserDetail from "../pages/company/users/UserDetail";
import RoleMatrix from "../pages/company/users/RoleMatrix";
import DepartmentList from "../pages/company/departments/DepartmentList";
import DepartmentDetail from "../pages/company/departments/DepartmentDetail";
import OrgMapping from "../pages/company/departments/OrgMapping";
import IntegrationHub from "../pages/company/integrations/IntegrationHub";
import MicrosoftSetup from "../pages/company/integrations/MicrosoftSetup";
import GoogleSetup from "../pages/company/integrations/GoogleSetup";
import WhatsAppSetup from "../pages/company/integrations/WhatsAppSetup";
import ChannelOverview from "../pages/company/channels/ChannelOverview";
import TeamsMenuBuilder from "../pages/company/channels/TeamsMenuBuilder";
import WhatsAppMenuBuilder from "../pages/company/channels/WhatsAppMenuBuilder";
import RuleList from "../pages/company/scheduling/RuleList";
import WorkingHours from "../pages/company/scheduling/WorkingHours";
import ResourceRules from "../pages/company/scheduling/ResourceRules";
import DirectoryExplorer from "../pages/company/directory/DirectoryExplorer";
import AliasManager from "../pages/company/directory/AliasManager";
import GroupMapping from "../pages/company/directory/GroupMapping";
import MeetingList from "../pages/company/meetings/MeetingList";
import MeetingDetail from "../pages/company/meetings/MeetingDetail";
import ManualBookingDesk from "../pages/company/meetings/ManualBookingDesk";
import TranscriptQueue from "../pages/company/transcripts/TranscriptQueue";
import MOMEditor from "../pages/company/transcripts/MOMEditor";
import ActionTracker from "../pages/company/transcripts/ActionTracker";
import CompanyTemplateList from "../pages/company/templates/TemplateList";
import CompanyTemplateEditorPage from "../pages/company/templates/TemplateEditor";
import ReminderMatrix from "../pages/company/notifications/ReminderMatrix";
import NotificationLog from "../pages/company/notifications/NotificationLog";
import EscalationRules from "../pages/company/notifications/EscalationRules";
import ReportsHub from "../pages/company/reports/ReportsHub";
import UtilizationReport from "../pages/company/reports/UtilizationReport";
import MeetingAnalytics from "../pages/company/reports/MeetingAnalytics";
import CompanyAuditExplorer from "../pages/company/audit/AuditExplorer";
import UserActivity from "../pages/company/audit/UserActivity";
import ExportHistory from "../pages/company/audit/ExportHistory";
import GeneralProfile from "../pages/company/settings/GeneralProfile";
import Branding from "../pages/company/settings/Branding";
import PoliciesRetention from "../pages/company/settings/PoliciesRetention";
import NotFoundPage from "../pages/shared/NotFoundPage";
import AuditLogs from "../pages/Auditlogs/Auditlogs";

const meetingHubCompanyRoutes = (
  <Fragment>
    <Route index element={<Navigate to="dashboard" replace />} />
    <Route path="dashboard/actions" element={<ActionCenter />} />
    <Route path="dashboard/schedule" element={<TodaysSchedule />} />
    <Route path="dashboard" element={<TenantDashboard />} />
    <Route path="users/roles" element={<RoleMatrix />} />
    <Route path="users/:id" element={<UserDetail />} />
    <Route path="users" element={<UserList />} />
    <Route path="departments/org-mapping" element={<OrgMapping />} />
    <Route path="departments/:id" element={<DepartmentDetail />} />
    <Route path="departments" element={<DepartmentList />} />
    <Route path="integrations/microsoft" element={<MicrosoftSetup />} />
    <Route path="integrations/google" element={<GoogleSetup />} />
    <Route path="integrations/whatsapp" element={<WhatsAppSetup />} />
    <Route path="integrations" element={<IntegrationHub />} />
    <Route path="channels/teams" element={<TeamsMenuBuilder />} />
    <Route path="channels/whatsapp" element={<WhatsAppMenuBuilder />} />
    <Route path="channels" element={<ChannelOverview />} />
    <Route path="scheduling/working-hours" element={<WorkingHours />} />
    <Route path="scheduling/resources" element={<ResourceRules />} />
    <Route path="scheduling" element={<RuleList />} />
    <Route path="directory/aliases" element={<AliasManager />} />
    <Route path="directory/groups" element={<GroupMapping />} />
    <Route path="directory" element={<DirectoryExplorer />} />
    <Route path="meetings/new" element={<ManualBookingDesk />} />
    <Route path="meetings/:id" element={<MeetingDetail />} />
    <Route path="meetings" element={<MeetingList />} />
    <Route path="transcripts/:meetingId/mom" element={<MOMEditor />} />
    <Route path="transcripts/actions" element={<ActionTracker />} />
    <Route path="transcripts" element={<TranscriptQueue />} />
    <Route path="templates/new" element={<CompanyTemplateEditorPage />} />
    <Route path="templates/:id" element={<CompanyTemplateEditorPage />} />
    <Route path="templates" element={<CompanyTemplateList />} />
    <Route path="notifications/log" element={<NotificationLog />} />
    <Route path="notifications/escalation" element={<EscalationRules />} />
    <Route path="notifications" element={<ReminderMatrix />} />
    <Route path="reports/utilization" element={<UtilizationReport />} />
    <Route path="reports/analytics" element={<MeetingAnalytics />} />
    <Route path="reports" element={<ReportsHub />} />
    <Route path="audit/user-activity" element={<UserActivity />} />
    <Route path="audit/exports" element={<ExportHistory />} />
    <Route path="audit" element={<AuditLogs />} />
    <Route path="settings/branding" element={<Branding />} />
    <Route path="settings/policies" element={<PoliciesRetention />} />
    <Route path="settings" element={<GeneralProfile />} />
    <Route path="*" element={<NotFoundPage />} />
  </Fragment>
);

export default meetingHubCompanyRoutes;
